import { render, staticRenderFns } from "./macaoInventoryRecordDetail.vue?vue&type=template&id=8a24ce3c&scoped=true"
import script from "./macaoInventoryRecordDetail.vue?vue&type=script&lang=js"
export * from "./macaoInventoryRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./macaoInventoryRecordDetail.vue?vue&type=style&index=0&id=8a24ce3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a24ce3c",
  null
  
)

export default component.exports